import URL from "./url"
import { camelizeObjKeys, snakeCaseObjKeys } from "./collection_helpers"

async function localFetch({
  path,
  jsonBody,
  params,
  accept,
  method = "POST",
  snakeCaseBody = true,
  opts = {},
  csrfToken = document.querySelector('meta[name="csrf-token"]')?.content,
  timeout = 5000,
}) {
  const base = {
    method,
    headers: {
      'X-CSRF-Token': csrfToken,
      'Content-Type': 'application/json',
      'Accept': accept
    },
    credentials: 'same-origin',
    ...opts
  }

  let body = jsonBody;

  if(body && snakeCaseBody) {
    body = snakeCaseObjKeys(body)
  }

  if(body) {
    base.body = JSON.stringify(body)
  }

  if(params !== undefined) {
    path = path + "?" + new URLSearchParams(snakeCaseObjKeys(params))
  }

  const controller = new AbortController();
  const signal = controller.signal;
  base.signal = signal;

  const fetchPromise = fetch(path, base);

  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => {
      reject({message: 'Request timed out'})
      controller.abort();
    }, timeout)
  );

  try {
    return await Promise.race([fetchPromise, timeoutPromise]);
  } catch(e) {
    return({error: e})
  }
}

async function fetchTurbo(opts) {
  const response = await localFetch({
    ...opts,
    accept: 'text/vnd.turbo-stream.html'
  })
  const html = await response.text()
  Turbo.renderStreamMessage(html)
}

async function fetchJSON(opts) {
  const response = await localFetch({
    ...opts,
    accept: 'application/json'
  })

  if(response.error) {
    return response
  } else {
    let json = await response.json()

    if(opts["camelizeResponseBody"]) {
      return camelizeObjKeys(json)
    } else {
      return json
    }
  }
}

async function fetchEmpty(opts) {
  return(await localFetch({ ...opts, accept: "*/*" }))
}

function withRedirectTo(opts = {}) {
  return async (response) => {
    const res = await response
    const redirect_to = res.headers.get("Redirect-To")
    if(res.status === 200 && redirect_to !== null) {
      let params = URL.params(redirect_to)

      if(opts.keepParams) {
        let keptParams
        if(opts.keepParams !== true) {
          keptParams = URL.slice(opts.keepParams)
        } else {
          keptParams = URL.params()
        }

        params = URL.mergeParams(params, keptParams)
      }

      const {pathname} = URL.url(redirect_to)

      if (opts.push) {
        URL.visitPush(params, pathname)
      } else {
        URL.visit(params, pathname)
      }
    }

    return res
  }
}


export { fetchEmpty, fetchJSON, fetchTurbo, withRedirectTo }
